var module = angular.module('main.customerinvoice');

module.component('caCustomerInvoiceRows',{
    templateUrl: 'main/customerinvoice/customerinvoicesearch/customerinvoicecontent/customerinvoicerows.cmp.tpl.html',
    bindings: {
        customerInvoice: '=',
        isEditing: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $translate, CustomerInvoiceApiService) {
    var vm = this;

    vm.customerInvoice = {};

    //Properties
    vm.currentRow = {};
    vm.rowCopy = {};

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.goToArticleVariant = goToArticle;
    vm.getEllipsis = getEllipsis;
    vm.isRowInvalid = isRowInvalid;
    vm.isTextInvalid = isTextInvalid;
    vm.getTotalCustomerinvoiceQuantity = getTotalCustomerinvoiceQuantity;
    vm.getTotalCustomerinvoiceAmount = getTotalCustomerinvoiceAmount;
    vm.getTotalCustomerinvoiceTotalAmount = getTotalCustomerinvoiceTotalAmount;
    vm.getTotalCustomerinvoiceVat = getTotalCustomerinvoiceVat;
    vm.getTotalCustomerinvoiceTotalVat = getTotalCustomerinvoiceTotalVat;
    vm.getTotalCustomerinvoiceWeight = getTotalCustomerinvoiceWeight;
    vm.getTotalCustomerinvoiceTotalWeight = getTotalCustomerinvoiceTotalWeight;

    function onInit() {

    }
    function onChanges() {
    }

    function getEllipsis(text, len) {
        if (text && text.length > len) {
            return text.substr(0, len) + '...';
        } else {
            return text;
        }
    }

    function isTextDifferent(text, field) {
        return vm.rowCopy[field] !== text;
    }

    function isRowInvalid(row) {
        return vm.isEditing ||
            (
                isTextInvalid(row.intrastatCode) ||
                (!row.weight || row.weight <= 0) ||
                isTextInvalid(row.currencyCode) ||
                isTextInvalid(row.countryOfOriginCode)
            );
    }

    function isTextInvalid(text) {
        return (text === undefined || text.trim().length === 0);
    }

    function getTotalCustomerinvoiceQuantity() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        return _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.quantity;
        });
    }
    function getTotalCustomerinvoiceAmount() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        var sum = _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.quantity > 0 ? (row.invoiceAmountExVat / row.quantity) : 0;
        });
        return sum;
    }
    function getTotalCustomerinvoiceTotalAmount() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        var sum = _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.invoiceAmountExVat;
        });
        return sum;
    }
    function getTotalCustomerinvoiceVat() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        var sum = _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.quantity > 0 ? (row.vatAmount / row.quantity) : 0;
        });
        return sum;
    }
    function getTotalCustomerinvoiceTotalVat() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        var sum = _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.vatAmount;
        });
        return sum;
    }
    function getTotalCustomerinvoiceWeight() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        return _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.quantity > 0 ? (row.weight / row.quantity) : 0;
        });
    }
    function getTotalCustomerinvoiceTotalWeight() {
        if (!vm.customerInvoice || !vm.customerInvoice.invoiceRows) { return 0; }
        return _.sumBy(vm.customerInvoice.invoiceRows, function(row) {
            return row.weight;
        });
    }

    function goToArticle(articleId) {
        $state.go('order.ordersearch.ordercontent.orderarticle', {orderArticleId: articleId});
    }
}
